import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { useEffect, useState } from 'react';
export var POPUP_POSITIONS = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  START: 'start',
  CENTER: 'center',
  END: 'end'
};
/**
 * @param {['top-start'|'top-center'|'top-end'|'bottom-start'|'bottom-center'|'bottom-end'|'left-start'|'left-center'|'left-end'|'right-start'|'right-center'|'right-end']} placement
 * @param {Space between target and popup element} triggerOffset
 * @returns
 */

export var getPositionStyles = function getPositionStyles() {
  var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bottom-start';
  var triggerOffset = arguments.length > 1 ? arguments[1] : undefined;
  var targetRef = arguments.length > 2 ? arguments[2] : undefined;
  var dimensions = arguments.length > 3 ? arguments[3] : undefined;
  var popRef = arguments.length > 4 ? arguments[4] : undefined;
  /**
   * placement:
   * primaryPositions: ["top", "right", "bottom", "left"]
   * secondaryPositions: ["start", "center", "end"]
   */

  var primaryPosition = placement.split('-')[0];
  var secondaryPosition = placement.split('-')[1];

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      targetDimension = _useState2[0],
      setTargetDimension = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      popupDimension = _useState4[0],
      setPopupDimension = _useState4[1];

  var isDocumentReady = document !== 'undefined';
  var documentSize = isDocumentReady && document.documentElement;
  var documentHeight = documentSize.clientHeight;
  var documentWidth = documentSize.clientWidth;
  useEffect(function () {
    if (dimensions) {
      setTargetDimension(targetRef.current.getBoundingClientRect());
      setPopupDimension(popRef.current.getBoundingClientRect());
    }
  }, [dimensions]);

  var getVerticalSecondaryPositionStyles = function getVerticalSecondaryPositionStyles(secondaryPosition) {
    if (secondaryPosition === POPUP_POSITIONS.START) {
      return {
        left: targetDimension.left
      };
    }

    if (secondaryPosition === POPUP_POSITIONS.CENTER) {
      return {
        left: targetDimension.left + targetDimension.width * 0.5,
        transform: 'translateX(-50%)'
      };
    }

    if (secondaryPosition === POPUP_POSITIONS.END) {
      return {
        right: documentWidth - targetDimension.right
      };
    }
  };

  var getHorizontalSecondaryPositionStyles = function getHorizontalSecondaryPositionStyles(secondaryPosition) {
    if (secondaryPosition === POPUP_POSITIONS.START) {
      return {
        top: targetDimension.top
      };
    }

    if (secondaryPosition === POPUP_POSITIONS.CENTER) {
      return {
        top: targetDimension.top + targetDimension.height * 0.5,
        transform: 'translateY(-50%)'
      };
    }

    if (secondaryPosition === POPUP_POSITIONS.END) {
      return {
        bottom: documentHeight - targetDimension.bottom
      };
    }
  };

  if (primaryPosition === POPUP_POSITIONS.TOP) {
    return _objectSpread({
      top: targetDimension.top - popupDimension.height - triggerOffset
    }, getVerticalSecondaryPositionStyles(secondaryPosition));
  }

  if (primaryPosition === POPUP_POSITIONS.BOTTOM) {
    return _objectSpread({
      top: targetDimension.bottom + triggerOffset
    }, getVerticalSecondaryPositionStyles(secondaryPosition));
  }

  if (primaryPosition === POPUP_POSITIONS.LEFT) {
    return _objectSpread({
      left: targetDimension.left - popupDimension.width - triggerOffset
    }, getHorizontalSecondaryPositionStyles(secondaryPosition));
  }

  if (primaryPosition === POPUP_POSITIONS.RIGHT) {
    return _objectSpread({
      left: targetDimension.right + triggerOffset
    }, getHorizontalSecondaryPositionStyles(secondaryPosition));
  }
};